export default __webpack_public_path__ + "./fonts/file.aa000357.svg";